import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { parseStandouts } from "@libertify/experience-viewer";
import { API_URL } from "@/constants";
import { useAuth } from "hooks/useAuth";
import { loadStandouts, standoutsKey } from "./helpers";
import type { ProjectDocument, StandoutsAsset } from "./types";

const NO_DOCUMENTS: ProjectDocument[] = [];

/** A project's Standouts on their own, cached across the edit card's remounts. */
export const useStandouts = (projectId: string): StandoutsAsset => {
  const { accessToken } = useAuth();
  const query = useQuery({
    queryKey: standoutsKey(projectId),
    queryFn: () => loadStandouts(projectId, accessToken),
    enabled: Boolean(API_URL && projectId && accessToken),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  const document = query.data?.document ?? null;
  const items = useMemo(() => parseStandouts(document), [document]);

  return {
    standouts: document?.standouts ?? [],
    items,
    assetId: query.data?.assetId,
    projectDocuments: query.data?.projectDocuments ?? NO_DOCUMENTS,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
};
